var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import withVisibility from '../../core/hoc/withVisibility';
import StyledSection from '../../styles/elements/Section';
const Section = (_a) => {
    var { children, customStyle } = _a, rest = __rest(_a, ["children", "customStyle"]);
    return (<StyledSection customStyle={customStyle} {...rest}>
    {children}
  </StyledSection>);
};
// This HOC can be splited to the containers later if required
export default withVisibility({ level: 'section' })(Section);
